import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { HTTPService } from 'src/app/main/services/HTTPService';
import CONFIG from 'src/app/main/urls/urls';

@Component({
  selector: 'app-check-out',
  templateUrl: './check-out.component.html',
  styleUrls: ['./check-out.component.css']
})
export class CheckOutComponent implements OnInit {

  checkoutForm: FormGroup;
  members$: any[] = [];
  books$: any[] = [];
  loading = false;
  submitted = false;

  constructor(
    private toastr: ToastrService,
    private fb: FormBuilder,
    private httpService: HTTPService,
    private activeModal: NgbActiveModal
  ) {}

  closeModal(): void {
    this.activeModal.dismiss();
  }

  ngOnInit() {
    this.checkoutForm = this.fb.group({
      member: ['', Validators.required],
      // Array of selected book IDs
      itemBarcodes: [[], Validators.required],
      dueDate: ['', Validators.required],
      automaticRenewal: ['', Validators.required],
    });

    this.getMembers();
    this.getBooks();
  }

  getMembers() {
    this.loading = true;
    this.httpService.getAll(CONFIG.URL_BASE + '/member/all').subscribe(
      (data: any[]) => {
        this.members$ = data;
        this.loading = false;
      },
      (err: HttpErrorResponse) => {
        this.loading = false;
        console.error('Error fetching members:', err.message);
      }
    );
  }

  getBooks() {
    this.loading = true;
    this.httpService.getAll(CONFIG.URL_BASE + '/book/all').subscribe(
      (data: any[]) => {
        this.books$ = data;
        this.loading = false;
      },
      (err: HttpErrorResponse) => {
        this.loading = false;
        console.error('Error fetching books:', err.message);
      }
    );
  }

  add() {
    this.submitted = true;

    if (!this.validateCheckoutForm()) {
      return;
    }

    const formValue = this.checkoutForm.value;
    const selectedBookIds: number[] = formValue.itemBarcodes.map((id: any) => parseInt(id));
    const selectedBooks = this.books$.filter(book => selectedBookIds.includes(book.id));

    if (selectedBooks.length === 0) {
      this.toastr.error('No valid items selected.');
      return;
    }

    // Fire one updateCirculationStatus call per selected book
    const statusName = 'CheckOut';
    const memberId = formValue.member;

    const updates = selectedBooks.map(book =>
      this.httpService
        .updateCirculationStatus(String(book.id), String(memberId), statusName)
        .toPromise()
    );

    Promise.all(updates)
      .then(() => {
        this.toastr.success(`${selectedBooks.length} item(s) checked out successfully.`);
        this.closeModal();
      })
      .catch(err => {
        console.error('Checkout error:', err);
        this.toastr.error('An error occurred during checkout.');
      });
  }

  validateCheckoutForm(): boolean {
    if (!this.checkoutForm) {
      this.toastr.error('Form is not initialized.');
      return false;
    }

    const formValue = this.checkoutForm.value;

    if (!formValue.member) {
      this.toastr.error('Please select a member.');
      return false;
    }

    if (!formValue.itemBarcodes || formValue.itemBarcodes.length === 0) {
      this.toastr.error('Please select at least one item barcode.');
      return false;
    }

    if (!formValue.dueDate) {
      this.toastr.error('Please select a due date.');
      return false;
    }

    const dueDate = new Date(formValue.dueDate);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (dueDate < today) {
      this.toastr.error('Due date cannot be in the past.');
      return false;
    }

    if (!['yes', 'no'].includes(formValue.automaticRenewal)) {
      this.toastr.error('Please select a valid option for automatic renewal.');
      return false;
    }

    return true;
  }
}